import { Injectable } from '@angular/core';
import { InspectionInfoFactoryService } from '../../inspectionInfo/inspectionInfo-plugin-factory.service';

@Injectable()
export class InstallationInspectionInfoFactoryService extends InspectionInfoFactoryService {}
